import {Box, Button, Flex, Heading, List, ListItem, useToast} from "@chakra-ui/react";
import React from "react";
import {useMutation, useQuery, useQueryClient} from "react-query";
import {useNavigate} from "react-router-dom";

import {
  deleteTest,
  getTests,
  postCandidates,
  postResources,
  postTests,
  postUsers
} from "../../shared/Api";
import UploadModal from "../../shared/components/UploadModal"
import {errorToast, successToast} from "../../shared/helper/ToastHelper";
import {disableBlurProtection} from "../../shared/hooks/BlurProtection";
import {Paths} from "../../shared/model/Constants";
import {adminKeys} from "../../shared/QueryKeys";
import { enableKeyCommands, extractData, saveByteArray } from "../../shared/Utils";
import CreateCandidate from "./CreateCandidate";
import CreateCertificates from "./CreateCertificates";
import CreateUser from "./CreateUser";
import TestItem from "./TestItem";
import UploadResources from "./UploadResources";

const Admin = () => {
  const queryClient = useQueryClient();
  const toast = useToast();
  const navigate = useNavigate();

  disableBlurProtection();
  enableKeyCommands();

  const testsQuery = useQuery(adminKeys.tests(), () =>
    getTests().then(extractData)
  );

  const uploadTestMutation = useMutation(postTests, {
    onSuccess: () => {
      successToast(toast, "Prueba subida");
      return queryClient.invalidateQueries(adminKeys.tests());
    },
    onError: () => {
      errorToast(toast, "Error subiendo prueba");
    },
  });

  const deleteTestMutation = useMutation(deleteTest, {
    onSuccess: () => {
      successToast(toast, "Prueba eliminada");
      return queryClient.invalidateQueries(adminKeys.tests());
    },
    onError: () => {
      errorToast(toast, "Error eliminando prueba");
    },
  });

  const createUserMutation = useMutation(postUsers, {
      onSuccess: (TData) => {
          successToast(toast, `Se crearon ${TData.data} usuarios`);
          return queryClient.invalidateQueries(adminKeys.users());
      },
      onError: () => {
          errorToast(toast, "Error creando usuarios");
      },
  });

  const createCandidateMutation = useMutation(postCandidates,
      {
          onSuccess: (TData) => {

            successToast(toast, "Usuarios creados");
            saveByteArray("Candidates", TData.data);
              //successToast(toast, `Se crearon ${TData.data} candidatos`);
              return queryClient.invalidateQueries(adminKeys.candidates());
          },
          onError: (error) => {
            console.log(error)
              errorToast(toast, "Error creando candidatos");
          },
      }
  );

  const uploadResourcesMutation = useMutation(({file, resourcesType}:any)=>
  postResources(file, resourcesType), {
    onSuccess: () => {
      successToast(toast, "Archivos subidos");
      return queryClient.invalidateQueries(adminKeys.tests());
    },
    onError: () => {
      errorToast(toast, "Error subiendo archivos");
    },
  });

  // <Button onClick={()=>{shutdown()}}>Shutdown</Button>
  return (
    <Box maxW="container.lg" marginX="auto">
      <Flex justify="space-between" align="center">
        <Heading paddingBottom="2">Usuarios</Heading>
        <Flex justify="right">
          <CreateUser
              onUserCreated={(file) => createUserMutation.mutate(file)}
          />
        </Flex>
        <Flex justify="right">
          <Button colorScheme="teal" onClick={()=>navigate(Paths.ADMIN_USERS)}>
            Ver usuarios
          </Button>
        </Flex>
      </Flex>
        <Flex justify="space-between" align="center">
            <Heading paddingBottom="2">Candidatos</Heading>
            <Flex justify="right">
              <CreateCandidate
                //onCandidateCreated={(file) => createCandidateMutation.mutate(file)}
              />
            </Flex>
            <Flex justify="right">
              <Button colorScheme="teal" onClick={()=>navigate(Paths.ADMIN_CANDIDATES+"?mock=all")}>
                Ver candidatos
              </Button>
            </Flex>
        </Flex>

      {/*
      <Button colorScheme="teal" onClick={()=>navigate(Paths.CREATE_PDFS)}>
        Crear constancias
      </Button>*/}
      <CreateCertificates
      />

      <Flex justify="space-between" align="center">
        <Heading paddingBottom="2">Pruebas</Heading>
        <Flex justify="right" gap="4" >
          <UploadResources
            onDataUploaded={(file, resourcesType) => uploadResourcesMutation.mutate({file, resourcesType})}
          />
          <UploadModal
            onDataUploaded={(file) => uploadTestMutation.mutate(file)}
              modalButton = "Crear prueba"
              modalHeader = "Nueva prueba"
              label = "Prueba"
              helperText = "Seleccione un archivo en formato yaml o xlsx para crear una prueba."
              sendButton = "Crear"
          />
        </Flex>
      </Flex>
      <List>
        {testsQuery.isSuccess && testsQuery.data.length ? (
          testsQuery.data.map((test) => (
            <TestItem
              key={test.id}
              test={test}
              onTestDeleted={(id) => deleteTestMutation.mutate(id)}
            />
          ))
        ) : (
          <ListItem>No hay pruebas</ListItem>
        )}
      </List>

      <Button colorScheme="teal" marginTop={10} onClick={()=>navigate(Paths.ADMIN_GLOBAL_PROPERTIES)}>
       Propiedades
      </Button>
    </Box>
  );
};

export default Admin;
